/* eslint-disable @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
import { Controller } from "stimulus";

export default class LocalSearchHistory extends Controller {
	declare iconValue: string;
	declare listTarget: HTMLDivElement;
	static values = {
		icon: String,
	};

	static targets = ["list"];

	connect() {
		this.displayLocalHistory();
		this.displayLocalHistory = this.displayLocalHistory.bind(this);
		// eslint-disable-next-line @typescript-eslint/unbound-method
		window.addEventListener("new_history_entry", this.displayLocalHistory);
	}

	disconnect(): void {
		// eslint-disable-next-line @typescript-eslint/unbound-method
		window.removeEventListener("new_history_entry", this.displayLocalHistory);
	}

	displayLocalHistory() {
		const searchQueryArray = Array.from(
			new Set(
				JSON.parse(localStorage.getItem("searchQuery") || "[]") as string[]
			).values()
		)
			.slice(-5)
			.reverse();

		this.listTarget.innerHTML = searchQueryArray
			.map(
				(query) => /* HTML */ `<a href="/szukaj/${query}">
					<div class="search-modal-queries-item">
						<div class="search-modal-queries-icon">
							<img src="${this.iconValue}" alt="search symbol" />
						</div>
						<div class="search-modal-queries-text">${query}</div>
					</div>
				</a>`
			)
			.join("");
	}

	clearHistory() {
		localStorage.removeItem("searchQuery");
		this.listTarget.innerHTML = "";
	}
}
